import qs from 'qs'
import { client } from '../utils'
import { gradebook as endpoints } from '../api_urls'

export const COURSENUM = window.location.pathname.split('/')[3]

export const startDownload = (data, filters) => {
  const baseUrl = endpoints.download()
  const url = filters != null ? `${baseUrl}?${qs.stringify(filters)}` : baseUrl

  return async () => {
    try {
      await client.post(url, data)
    } catch (error) {
      return reportError('Initiating the gradebook download task failed.')
    }
    window.$('#widget_container').trigger('reload_widgets')
  }
}

export const fetchGradebookData = data => {
  return async dispatch => {
    try {
      var response = await client.get(
        `${endpoints.index()}?${qs.stringify(data)}`
      )
    } catch (error) {
      return reportError('Getting the gradebook data failed.')
    }

    if (response.data.error === 'invalid_page') {
      return reportError('This is an invalid page.')
    } else {
      dispatch(changePage(data.page || 1))
      let gradebook = response.data.gradebook
      dispatch(updateGradebook(gradebook))
      dispatch(updateIsCanvasCourse(response.data.isCanvasCourse))
      dispatch(updateDimensions())
      dispatch(handleScroll())
    }
  }
}

export const updateDimensions = () => {
  return () => {
    const container = $('#gradebook_table_container')
    const gradebookBottom = $('#gradebook_bottom')
    const gradebookTopLeft = $('div#gradebook_top_left')
    const gradebookTopRight = $('div#gradebook_top_right')
    const gradebookBottomLeft = $('div#gradebook_bottom_left')
    const gradebookBottomRight = $('div#gradebook_bottom_right')

    const containerWidth = container.innerWidth()
    const leftWidth = gradebookTopLeft.width()
    const rightWidth = containerWidth - leftWidth
    gradebookTopRight.width(rightWidth)
    gradebookBottomRight.width(rightWidth)

    let bottomHeight = 400
    try {
      bottomHeight = $(window).height() - gradebookBottom.offset().top - 100
      gradebookBottomLeft.height(bottomHeight)
      gradebookBottomRight.height(bottomHeight)
    } catch (error) {
      gradebookBottomLeft.height(bottomHeight)
      gradebookBottomRight.height(bottomHeight)
      return
    }
  }
}

export const handleScroll = () => {
  return () => {
    const gradebookBottomRight = document.getElementById(
      'gradebook_bottom_right'
    )
    const gradebookTopRight = document.getElementById('gradebook_top_right')
    const gradebookBottomLeft = document.getElementById('gradebook_bottom_left')
    try {
      gradebookBottomRight.addEventListener('scroll', function () {
        gradebookTopRight.scrollLeft = gradebookBottomRight.scrollLeft
        gradebookBottomLeft.scrollTop = gradebookBottomRight.scrollTop
      })
    } catch (error) {
      return
    }
  }
}

export const fetchSections = () => {
  return async dispatch => {
    try {
      var response = await client.get(endpoints.sections())
    } catch (error) {
      return reportError('Getting the section data failed.', error)
    }
    let sections = response.data.sections
    dispatch(updateSections(sections))
  }
}

export const fetchModalBody = (activityID, studentID) => {
  return async dispatch => {
    try {
      var response = await client.get(
        endpoints.popover({ activityID, studentID })
      )
    } catch (error) {
      return reportError('Getting the submission data failed.')
    }
    dispatch(updateModal({ modalBody: response.data }))
  }
}

export const updateSections = sections => {
  return {
    type: 'UPDATE_SECTIONS',
    payload: sections,
  }
}

export const updateGradebook = gradebook => {
  return {
    type: 'UPDATE_GRADEBOOK',
    payload: gradebook,
  }
}

const updateIsCanvasCourse = isCanvasCourse => {
  return {
    type: 'UPDATE_ISCANVASCOURSE',
    payload: isCanvasCourse,
  }
}

export const changePage = page => {
  return {
    type: 'CHANGE_PAGE',
    payload: page,
  }
}

export const updateFilters = filters => {
  return {
    type: 'UPDATE_FILTERS',
    payload: filters,
  }
}

export const updateScoreFormat = toggle => {
  return {
    type: 'UPDATE_SCORE_FORMAT',
    payload: toggle,
  }
}

export const updateModal = modalState => {
  return {
    type: 'UPDATE_MODAL',
    payload: modalState,
  }
}

export const reportError = message => {
  window.$.meDialog.topMessage(
    `${message} Contact MyEducator support.`,
    6000,
    'danger'
  )
}
